"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * Get current or cached selection range
 * @param core The EditorCore object
 * @param tryGetFromCache Set to true to retrieve the selection range from cache if editor doesn't own the focus now
 * @returns A Range object of the selection range
 */
exports.getSelectionRange = function (core, tryGetFromCache) {
    var result = null;
    if (!tryGetFromCache || core.api.hasFocus(core)) {
        var selection = core.document.defaultView.getSelection();
        if (selection && selection.rangeCount > 0) {
            var range = selection.getRangeAt(0);
            if (roosterjs_editor_dom_1.contains(core.contentDiv, range)) {
                result = range;
            }
        }
    }
    if (!result && tryGetFromCache) {
        result = core.cachedSelectionRange;
    }
    return result;
};
//# sourceMappingURL=getSelectionRange.js.map